import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';

export const BreadcrumbList = ({ items }) => {
    return (
        <Breadcrumb className="mt-3">
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                Início
            </Breadcrumb.Item>
            {items.map((item, index) => (
                <Breadcrumb.Item
                    key={index}
                    linkAs={index === items.length - 1 ? 'span' : Link}
                    linkProps={index === items.length - 1 ? {} : { to: item.url }}
                    active={index === items.length - 1}
                >
                    {item.name}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
}; 